import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import {connect} from "react-redux";
import { changeEmail } from 'redux/users/actions';

import { Field, reduxForm, formValueSelector } from 'redux-form';
import { Form } from 'semantic-ui-react';
import TextField from 'components/redux-form-adapters/TextField';
import Button from 'components/elements/buttons/Button';
import CommonMessage from 'components/common/CommonMessage';

import validate from './validate';

import './ChangeEmailForm.css';


function ChangeEmailForm(props) {
  const {
    changeEmail,
    handleSubmit,
    valid,
    password,
    email,
    email2,
    changeEmailError,
  } = props;
  const { t } = useTranslation();

  const _handleSubmit = () => {
    const form = new FormData();
    form.append('password', password);
    form.append('email', email);
    form.append('email2', email2);
    changeEmail(form);
  };

  return (
    <div className="change-email-form__component">
      <Form
        onSubmit={handleSubmit(_handleSubmit)}
        error={!valid}
      >
        <Field
          component={TextField}
          name="password"
          type="password"
          placeholder={t("Your password")}
          required
        />
        <Field
          component={TextField}
          name="email"
          type="email"
          placeholder={t("New email")}
          required
        />
        <Field
          component={TextField}
          name="email2"
          type="email"
          placeholder={t("Confirm new email")}
          required
        />
        {changeEmailError &&
          <CommonMessage
            error
            errors={changeEmailError}
          />
        }
        <Button small submit>{t("Change Email")}</Button>
      </Form>
    </div>
  );
}

ChangeEmailForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  changeEmail: PropTypes.func.isRequired,
  valid: PropTypes.bool.isRequired,
  password: PropTypes.string,
  email: PropTypes.string,
  email2: PropTypes.string,
  changeEmailError: PropTypes.object,
  me: PropTypes.object,
};

ChangeEmailForm.defaultProps = {
  password: null,
  email: null,
  email2: null,
  changeEmailError: null,
  me: null
};

const mapStateToProps = (state) => {
  const selector = formValueSelector('ChangeEmailForm');
  return {
    password: selector(state, 'password'),
    email: selector(state, 'email'),
    email2: selector(state, 'email2'),
    changeEmailError: state.usersReducer.changeEmailError,
    me: state.usersReducer.me,
  };
};

export default connect(
  mapStateToProps,
  {
    changeEmail,
  },
)(reduxForm({
  form: 'ChangeEmailForm',
  validate,
})(ChangeEmailForm));
